/*
* OCR BASE: PROTO
* Author: @thinkdj
* Date: 06 March 2019
*/

import { Component, OnInit } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest, HttpResponse } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';

@Component({
  selector: 'app-ocr-base',
  templateUrl: './ocr-base.component.html',
  styleUrls: ['./ocr-base.component.scss']
})
export class UIOcrBaseComponent implements OnInit {

  apiKeyGoogVision: string = "AIzaSyAGQp130NDYtm-y0e3jG2hTrrgNQHj4Su8";
  apiEndPoint:string = "https://vision.googleapis.com/v1/images:annotate?key=";
  apiBody: any = {
    "requests":[
      {
        "image": {
          "content": "----InsertBase64EncodedImage----"
        },
        "imageContext": {
          "webDetectionParams": {
            "includeGeoResults": true
          },
        },
        "features": [
          {
            "type": "LABEL_DETECTION",
            "maxResults": 10
          },
          {
            "type": "FACE_DETECTION",
            "maxResults": 5
          },
          {
            "type": "WEB_DETECTION",
            "maxResults": 10
          },
          {
            "type": "TEXT_DETECTION"
          },
          {
            "type": "DOCUMENT_TEXT_DETECTION"
          }
        ],
        },
      ]
  };

  loading = false;
  avatarUrl: string = '';

  constructor(
      private msg: NzMessageService,
      private http: HttpClient,
  ) { }

  ngOnInit() {
  }

  item: any = {};
  messageId: any = null;
  ocrResults: any = null;
  ocrCustomResults: any = null;

  /* Common checks */
  preUploadImgChecks = (file: File) => {
    return new Observable((observer: Observer<boolean>) => {
      const maxFileSize = 4; /* MB */
      const isImage = file.type.includes('image');
      if (!isImage) {
        this.msg.error(`Unsupported file. Please select an Image`);
        observer.complete();
        return;
      }
      const fileSizeOK = file.size / 1024 / 1024 < maxFileSize;
      if (!fileSizeOK) {
        this.msg.error(`Image must smaller than ${maxFileSize} MB`);
        observer.complete();
        return;
      }
      observer.next(isImage && fileSizeOK);
      observer.complete();
      return;
    });
  };
  deleteUploadedImage = (file: any) : boolean => {
    this.ocrCustomResults = null;
    return true;  /* true => Proceed with deletion from UI component */
  };

  /* Header Image */
  imgHeaderList = [];
  headerPreviewImage: any = false;
  headerImgPreviewVisible: boolean = false;
  headerImgPreview = (file: NzUploadFile) => { /* (file: UploadFile) => boolean｜Observable */
    this.headerPreviewImage = file.url || file.thumbUrl;
    this.headerImgPreviewVisible = true;
  };
  headerImgUpdated(e:any) {
    switch (e.type) { /* e.type：start, progress, success, removed */
      case 'start':
        if(this.messageId) this.msg.remove(this.messageId); /* Remove Message if it exists */
        this.messageId = this.msg.loading('Processing ...', { nzDuration: 0 }).messageId;

      case 'success':
        /* Set Preview */
        //this.item.image = e.file.response.url;
        this.headerPreviewImage = e.file.url || e.file.thumbUrl;
        /* Set Item data */
        //this.setItemHeaderImg();
        //break;
      case 'error':
          let base64 = (e.file.thumbUrl.split(","))[1];
          let base64str: string = base64;
          this.apiBody = {
            "requests":[
              {
                "image": {
                  "content": base64str
                },
                "imageContext": {
                  "webDetectionParams": {
                    "includeGeoResults": true
                  },
                },
                "features": [
                  {
                    "type": "LABEL_DETECTION",
                    "maxResults": 10
                  },
                  {
                    "type": "FACE_DETECTION",
                    "maxResults": 5
                  },
                  {
                    "type": "WEB_DETECTION",
                    "maxResults": 10
                  },
                  {
                    "type": "TEXT_DETECTION"
                  },
                  {
                    "type": "DOCUMENT_TEXT_DETECTION"
                  }
                ],
              },
            ]
          };
          console.log(this.apiBody);

        this.http.post(this.apiEndPoint+this.apiKeyGoogVision, this.apiBody)
            .subscribe( data => {
              var temp:any = data;
              this.msg.remove(this.messageId); /* Remove Message */
              this.ocrResults = temp.responses[0];
              this.ocrCustomResults = {
                'faces': this.ocrResults.faceAnnotations?this.ocrResults.faceAnnotations.length:0,
                'labels': this.ocrResults.labelAnnotations?this.ocrResults.labelAnnotations.map(item => {return item.description}):null,
                'guesses': this.ocrResults.webDetection.webEntities?this.ocrResults.webDetection.webEntities.map(item => {return item.description}):null,
                'text': this.ocrResults.textAnnotations?this.ocrResults.textAnnotations.map(item => {return item.description}):null,
              };

              let tempStr = String(this.ocrCustomResults.text[0]);
              this.ocrCustomResults.textLine = tempStr.replace(/\n/g,' ').replace(/\t/g,' ').replace(/\s{2,}/g, ' '); // All text in one line

              this.ocrCustomResults.textCustom = this.ocrCustomResults.text[0].split('\n'); // All text

              this.ocrCustomResults.guesses.forEach( item=> {
                if("Permanent account number"==item) this.ocrCustomResults.documentBestGuess = "PAN Card";
                if("Passport"==item) this.ocrCustomResults.documentBestGuess = "Passport";
                if(!this.ocrCustomResults.documentBestGuess && "Driver's license"==item) this.ocrCustomResults.documentBestGuess = "Driving License";
                if("UIDAI"==item) this.ocrCustomResults.documentBestGuess = "Aadhar Card";
                if("Aadhar"==item) this.ocrCustomResults.documentBestGuess = "Aadhar Card";
              });


              this.ocrCustomResults.hasValidDocumentId = false;
              this.ocrCustomResults.textCustom.forEach( item=> {

                /* Indian Aadhar */
                if(/^\d{4}\s\d{4}\s\d{4}$/g.test(item)){
                  this.ocrCustomResults.documentId = item;
                  this.ocrCustomResults.hasValidDocumentId = true;
                }

                /* Remove whitespaces for further processing */
                item = item.replace(/\s/g,'');

                /* Indian PAN */
                if(/[A-Za-z]{5}\d{4}[A-Za-z]{1}/g.test(item)){
                  this.ocrCustomResults.documentId = item;
                  this.ocrCustomResults.hasValidDocumentId = true;
                }
                /* Indian Passport */
                if(/^[A-Z]{1}[0-9]{7}$/.test(item)){
                  this.ocrCustomResults.documentId = item;
                  this.ocrCustomResults.hasValidDocumentId = true;
                }

                /* Indonesian Driving License ID */
                if(!this.ocrCustomResults.hasValidDocumentId && /\d{8}/.test(item)){
                  this.ocrCustomResults.documentId = item;
                  this.ocrCustomResults.hasValidDocumentId = true;
                }

              });

              /* Guess Country of Issuance */
              this.ocrCustomResults.guesses.forEach( item=> {
                if(["India","Indonesia","USA","Canada","Singapore"].includes(item)){
                  this.ocrCustomResults.documentCountry = item;
                }
              });
              if(!this.ocrCustomResults.documentCountry) {
                this.ocrCustomResults.text.forEach( item=> {
                  item = item.toLowerCase().replace(/\b[a-z]/g, match => match.toUpperCase());
                  if(["India","Indonesia","USA","Canada","Singapore"].includes(item)){
                    this.ocrCustomResults.documentCountry = item;
                  }
                })
              }

              /* Re check validity */
              this.ocrCustomResults.isValid = false;
              if(this.ocrCustomResults.hasValidDocumentId) {
                this.ocrCustomResults.isValid = true;
              }
              else if (this.ocrCustomResults.faces==1) this.ocrCustomResults.isValid = true;

            });

        break;
      case 'start':
      case 'progress':
        break;
      case 'removed':
        /* Reset Preview */
        this.headerPreviewImage = false;
        this.headerImgPreviewVisible = false;
        /* Reset Item data */
        //this.setItemHeaderImg();
        break;
    }
    console.log("File Status: ",e);
  }

  setItemHeaderImg() {
    /* Set Header Img Array */
    this.item.image_header = this.imgHeaderList
        .filter(item=>{ return !(item.status=='removed') })
        .map(item => ({id: item.response.id, url: item.response.url, path: item.response.path, meta: item.response.meta}));
    /* If no images, unset item.image */
    if(!this.item.image_header.length) this.item.image = null;
  }
  backgroundImgHeader = '';

  private getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result.toString()));
    reader.readAsDataURL(img);
  }


}
